export const NEXT_ACTIVE_STEP_SUCCESS = 'NEXT_ACTIVE_STEP_SUCCESS';
export const NEXT_ACTIVE_STEP_FAIL = 'NEXT_ACTIVE_STEP_FAIL';

export const PREVIOUS_ACTIVE_STEP_SUCCESS = 'PREVIOUS_ACTIVE_STEP_SUCCESS';
export const PREVIOUS_ACTIVE_STEP_FAIL = 'PREVIOUS_ACTIVE_STEP_FAIL';

export const GO_TO_STEP_SUCCESS = 'GO_TO_STEP_SUCCESS';
export const GO_TO_STEP_FAIL = 'GO_TO_STEP_FAIL';

export const SAVE_AGREEMENT_SUCCESS = 'SAVE_AGREEMENT_SUCCESS';
export const SAVE_AGREEMENT_FAIL = 'SAVE_AGREEMENT_FAIL';

export const LOAD_EXTERIOR_SUCCESS = 'LOAD_EXTERIOR_SUCCESS';
export const LOAD_EXTERIOR_FAIL = 'LOAD_EXTERIOR_FAIL';

export const LOAD_FLOORPLANS_SUCCESS = 'LOAD_FLOORPLANS_SUCCESS';
export const LOAD_FLOORPLANS_FAIL = 'LOAD_FLOORPLANS_FAIL';

export const CLEAR_AGREEMENT_SUCCESS = 'CLEAR_AGREEMENT_SUCCESS';
export const CLEAR_AGREEMENT_FAIL = 'CLEAR_AGREEMENT_FAIL';

export const GET_AGREEMENT_BY_ID_SUCCESS = 'GET_AGREEMENT_BY_ID_SUCCESS';
export const GET_AGREEMENT_BY_ID_FAIL = 'GET_AGREEMENT_BY_ID_FAIL';

export const REMOVE_SECOND_CLIENT_SUCCESS = 'REMOVE_SECOND_CLIENT_SUCCESS';
export const REMOVE_SECOND_CLIENT_FAIL = 'REMOVE_SECOND_CLIENT_FAIL';

export const GET_OPTION_DETAILS_SUCCESS = 'GET_OPTION_DETAILS_SUCCESS';
export const GET_OPTION_DETAILS_FAIL = 'GET_OPTION_DETAILS_FAIL';

export const RESET_AGREEMENT_SUCCESS = 'RESET_AGREEMENT_SUCCESS';
export const RESET_AGREEMENT_FAIL = 'RESET_AGREEMENT_FAIL';

export const SET_LOADING_SUCCESS = 'SET_LOADING_SUCCESS';
export const SET_LOADING_FAIL = 'SET_LOADING_FAIL';

export const SAVE_PERSISTED_DATA_SUCCESS = 'SAVE_PERSISTED_DATA_SUCCESS';
export const SAVE_PERSISTED_DATA_FAIL = 'SAVE_PERSISTED_DATA_FAIL';

export const GET_DEPOSIT_SCHEDULE_SUCCESS = 'GET_DEPOSIT_SCHEDULE_SUCCESS';
export const GET_DEPOSIT_SCHEDULE_FAIL = 'GET_DEPOSIT_SCHEDULE_FAIL';
